/* @flow */
import * as React from 'react';
// $FlowIssue: this will be resolved when we upgrade flow. React defs are out of date
import { createPortal } from 'react-dom';

/**
 * A simple helper to avoid hardcoding the selector for the portal target in
 * various parts of the app.
 */
export const renderPortal = (component: React.Element<*>) => {
  const target = document.querySelector('#portalTarget');

  // Just in case the App itself hasn't rendered yet.
  if (!target) {
    console.warn('[WARN] Portal target not found.');
    return null;
  }

  return createPortal(component, target);
};



// WEBPACK FOOTER //
// ./web_modules/trustar/dom-utils/index.js